import styled from 'styled-components';
import cn from 'classnames';

export const Inner = styled.span`
  position: relative;
  top: -1px;
`;

export const Button = styled.button.attrs(({ type, size, htmlType }) => {
  return {
    className: cn('btn', {
      btn_shading: type === 'shading',
      btn_primary: type === 'primary',
      btn_secondary: type === 'secondary',
      btn_cart: type === 'cart',
      btn_buy: type === 'buy',
      btn_order: type === 'order',
      btn_sort: type === 'sort',
      btn_search: type === 'search',
      'btn_secondary-round': type === 'secondary-round',
      'btn_offer-secondary': type === 'offer-quick-buy',
      'btn_offer-primary': type === 'offer-buy',
      btn_middle: size === 'middle',
      btn_small: size === 'small',
      btn_large: size === 'large',
      btn_stroke:
        type === 'secondary' &&
        document.documentElement.style.getPropertyValue(
          '--secondary-btn-stroke'
        ) !== 'transparent',
      btn_filter: type === 'filter',
    }),
    type: htmlType ?? 'button',
  };
})`
  display: inline-block;
  vertical-align: middle;
  border: none;
  background: none;
  border-radius: 6px;
  cursor: pointer;
  font-weight: 600;
  font-family: var(--primary-font), sans-serif;
  font-size: 13px;
  line-height: 1.38em;
  padding: 7px 10px;
  color: var(--carbone100);
  white-space: nowrap;
  transition: var(--transition);

  &.btn_shading {
    font-size: 14px;
    line-height: 1.43em;
    border: 1px solid var(--aluminium75);
    border-radius: 4px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08), 0 2px 7px rgba(0, 0, 0, 0.08);

    &:hover {
      border-color: var(--carbone80);
    }
  }

  &:focus {
    outline: none;
  }

  &.btn_small {
    padding: 8px 10px;
    height: 40px;
    letter-spacing: -0.03em;
  }

  &.btn_middle {
    font-size: 14px;
    line-height: 1.43em;
    padding: 14px 28px;
    height: 48px;
  }

  &.btn_large {
    font-size: 15px;
    line-height: 1.33em;
    padding: 16px 21px;
    height: 52px;

    &.btn_cart {
      padding: 16px 32px;
    }
  }

  &.btn_primary,
  &.btn_order {
    background: var(--theme-palette-buttons-primary-bg);
    color: var(--theme-palette-buttons-primary-color);

    &:hover {
      background: var(--theme-palette-buttons-primary-bg-hover);
    }
  }

  &.btn_secondary {
    background: var(--theme-palette-buttons-secondary-bg);
    color: var(--theme-palette-buttons-secondary-color);
    border: 2px solid transparent;

    &.btn_middle {
      padding: 10px 21px;
    }

    &.btn_stroke {
      border-color: var(--theme-palette-buttons-secondary-stroke);

      &:hover {
        border-color: var(--theme-palette-buttons-secondary-bg-hover);
      }
    }
  }

  &.btn_secondary-round {
    border: 1px solid var(--aluminium60);
    border-radius: 50px;
    padding: 10px 16px;

    &:hover {
      border-color: var(--aluminium100);
    }

    &.is-active {
      box-shadow: inset 0 0 0 1px var(--blue120);
      border-color: var(--blue120);
    }
  }

  &.btn_buy {
    font-size: 12px;
    line-height: 1.17em;
    color: var(--theme-palette-buttons-secondary-btn-buy-color);
    background: var(--theme-palette-buttons-secondary-btn-buy-bg);
    border: 2px solid var(--theme-palette-buttons-secondary-btn-buy-stroke);
    padding: 10px;
    width: 90px;
    height: 40px;
    border-radius: 4px;
  }

  &.btn_cart {
    background: var(--theme-palette-buttons-primary-bg);
    color: var(--white);

    &:hover {
      background: var(--theme-palette-buttons-primary-bg-hover);
    }
  }

  &.btn_order.btn_middle {
    min-width: 153px;
    padding: 10px 21px;
  }

  &.btn_sort {
    padding: 11px 16px;
    background: var(--theme-palette-buttons-primary-bg);
    color: var(--white);

    &:hover {
      background: var(--theme-palette-buttons-primary-bg-hover);
    }
  }

  &.btn_offer-secondary,
  &.btn_offer-primary {
    padding: 8px 12px;
    height: 38px;
    line-height: 1.53em;
    border-radius: 4px;
  }

  &.btn_offer-primary {
    background: var(--theme-palette-buttons-primary-bg);
    color: var(--white);

    &:hover {
      background: var(--theme-palette-buttons-primary-bg-hover);
    }
  }

  &.btn_offer-secondary {
    border: 1px solid var(--aluminium35);
    color: var(--theme-palette-buttons-primary-color)

    &:hover {
      border-color: var(--aluminium100);
    }
  }

  &.btn_filter {
    background: var(--white);
    font-size: 14px;
    line-height: 1.43em;
    border: 1px solid var(--aluminium75);
    border-radius: 50px;
    padding: 10px 16px;

    &:hover {
      border-color: var(--carbone80);
    }
  }

  &&.btn_search {
    width: 92px;
    background: var(--aluminium35);
    border: none;
    font-weight: 400;
    color: var(--grey70);
    box-shadow: none;
    margin-right: 0;
    padding: 0 6px;
    border-radius: 0;
    flex-shrink: 0;
    margin-bottom: -1px;
  }

  &:not(:last-child) {
    margin-right: 12px;
  }

  &:last-child {
    margin-right: 0;
  }

  &&&:disabled {
    background: var(--aluminium100);
    border-color: var(--aluminium100);
    color: var(--white);
    cursor: not-allowed;
  }

  && ${Inner} {
    display: inline;
  }
`;
